import React from 'react'
import PageTemplate from '../../components/common/PageTemplate'
import PageHeaderContainer from '../../containers/common/PageHeaderContainer'
import ContentTemplate from '../../components/common/ContentTemplate'
import PageTitleTemplate from '../../components/common/PageTitleTemplate'
import Breadcrumb from '../../components/common/Breadcrumb'
import UnlockAccount from '../../components/auth/unlock/UnlockAccount'
import { UNLOCK_ACCOUNT_PAGE } from '../../constants/page'

const UnlockAccountPage = () => {
  return (
    <PageTemplate className='member'>
      <PageHeaderContainer title={UNLOCK_ACCOUNT_PAGE.title} image={require('../../assets/img/login/sub_tit_membership.png')} />
      <ContentTemplate>
        <PageTitleTemplate>
          <Breadcrumb page={UNLOCK_ACCOUNT_PAGE} />
        </PageTitleTemplate>
        <UnlockAccount />
      </ContentTemplate>
    </PageTemplate>
  )
}

export default UnlockAccountPage
